import * as React from 'react'
import { classNames } from '@common/utils/helpers'
import styled from '@emotion/styled'
import CardFooter from './card-footer'

interface CardContentProps extends React.HTMLAttributes<HTMLElement> {
  className?: string | undefined
  style?: any
}

interface CardContent extends React.FC<CardContentProps> {
  Footer?: CardFooter
}

const CardContentWrapper = styled.div`
  &.pq-card-content {
    display: flex;
    flex-direction: column;
  }
`

/**
 * @deprecated use {@palqee/ui/card}
 */
const CardContent: CardContent = (props) => {
  const { children, className, ...rest } = props
  const classes = classNames('pq-card-content', className || '')
  return (
    <CardContentWrapper className={classes} {...rest}>
      {children}
    </CardContentWrapper>
  )
}

CardContent.Footer = CardFooter

export { CardContent }
